import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import CityPicker from "src/components/CityPicker";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";

const TABLE_HEAD = [
  { id: "idx", label: "排名", alignRight: false },
  { id: "name", label: "铁军", alignRight: false },
  // { id: "yearly", label: "年业绩（元）", alignRight: false },
  // { id: "monthly", label: "月业绩（元）", alignRight: false },
  // { id: "yesterday", label: "昨日业绩（元）", alignRight: false },
  // { id: "today", label: "今日业绩（元）", alignRight: false },
  { id: "rangli", label: "业绩", alignRight: false, sortable: true },
  { id: "count", label: "消费笔数", alignRight: false, sortable: true },
  { id: "mersAdded", label: "新增商户", alignRight: false },
  { id: "mersTotal", label: "累计商户", alignRight: false, sortable: true },
  // { id: "daily", label: "业绩", alignRight: false },
  // { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 },
];

const timeList = [
  { label: "本年业绩", value: "year" },
  { label: "上月业绩", value: "lastMonth" },
  { label: "本月业绩", value: "month" },
  { label: "上周业绩", value: "lastWeek" },
  { label: "本周业绩", value: "week" },
  { label: "昨日业绩", value: "yesterday" },
  { label: "今日业绩", value: "today" },
];

export default function TiejunRank() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [targetMerchant, setTargetMerchant] = useState(null);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [showYinshou, setShowYinshou] = useState(false);
  const [dailyTotal, setDailyTotal] = useState({});

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    provinceId: null,
    cityId: null,
    districtId: null,
    createdAt: null,
    sort: 'rangli',
    time: 'today',
    order: 'desc',
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/stats/tiejun/rankv2",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  async function getDailyTotal() {
    const { data } = await asyncRequest({
      path: "/stats/daily",
      data: filter,
    });

    setDailyTotal(data);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/merchant/edit/${row.mid}`, { state: row });
    }
  };

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  function handleRequestSort(value) {
    console.log(value);
    const order = filter.sort == value ? (filter.order == "asc" ? "desc" : "asc") : "asc";
    setFilter({
      ...filter,
      page: 0,
      sort: value,
      order,
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="铁军业绩排行">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              铁军业绩排行
            </Typography>
          </Stack>

          <Card>
            <ListToolbar
              filterName={filter.search}
              onFilterName={handleFilterByName}
              onRefresh={() => {
                getItems();
                // getDailyTotal();
              }}
            >
              <MyDateRangePicker
                value={filter.createdAt}
                onChange={(val) => {
                  setFilter({
                    ...filter,
                    createdAt: val,
                  });
                }}
              />

              <FormControl size="small">
                <InputLabel id="demo-simple-select-label">检索方式</InputLabel>
                <Select
                  // labelId="demo-simple-select-label"
                  // id="demo-simple-select"
                  label="检索方式"
                  value={filter.time}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      time: e.target.value,
                    });
                  }}
                  style={{ width: 250 }}
                >
                  {timeList.map((item, idx) => (
                    <MenuItem key={idx} value={item.value} name={item}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  {/* <TableRow>
                    <TableCell>
                      {!!filter.createdAt ? (
                        <Stack>
                          <Typography>总业绩：{dailyTotal.total}元</Typography>
                        </Stack>
                      ) : (
                        <Stack>
                          <Typography>年度业绩：{dailyTotal.yearly}元</Typography>
                          <Typography>上月业绩：{dailyTotal.lastMonthly}元</Typography>
                          <Typography>本月业绩：{dailyTotal.monthly}元</Typography>
                          <Typography>昨日业绩：{dailyTotal.yesterday}元</Typography>
                          <Typography>今日业绩：{dailyTotal.today}元</Typography>
                        </Stack>
                      )}
                    </TableCell>
                  </TableRow> */}
                  <ListHead headLabel={TABLE_HEAD} orderBy={filter.sort} order={filter.order} onRequestSort={handleRequestSort} />
                  <TableBody>
                    {items.map((row, idx) => {
                      const { tid, count, mersAdded, mersTotal, user, rangli, realname } = row;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={tid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, mid)}
                            />
                          </TableCell> */}
                          {/* <TableCell align="left">{mid}</TableCell> */}
                          <TableCell align="left">{idx + 1}</TableCell>
                          <TableCell align="left">
                            <UserInfo {...user} />
                          </TableCell>

                          <TableCell align="left">{rangli.toFixed(2)}</TableCell>
                          <TableCell align="left">{count}</TableCell>
                          <TableCell align="left">{mersAdded}</TableCell>
                          <TableCell align="left">{mersTotal}</TableCell>

                          {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}
                          <TableCell align="right">{/* <MoreMenu spread={false} menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} /> */}</TableCell>
                        </TableRow>
                      );
                    })}

                    {/* <TableRow>
                      <TableCell>
                        <Stack>
                          <Typography>年度业绩：{dailyTotal.yearly}元</Typography>
                          <Typography>本度业绩：{dailyTotal.monthly}元</Typography>
                          <Typography>昨日业绩：{dailyTotal.yesterday}元</Typography>
                          <Typography>今日业绩：{dailyTotal.today}元</Typography>
                        </Stack>
                      </TableCell>
                    </TableRow> */}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Card>
        </Container>
      </Page>
    </>
  );
}
